import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class ApplicationValidatorService {
  private applicationFormValid = new BehaviorSubject(false);
  private invalidControlScroll = new BehaviorSubject(false);

  constructor() {
  }

  getApplicationFormState(): Observable<any> {
    return this.applicationFormValid.asObservable();
  }

  changeState(state: any) {
    this.applicationFormValid.next(state);
  }

  getInvalidControlScrollObservable(): Observable<any> {
    return this.invalidControlScroll.asObservable();
  }

  emitScrollEvent() {
    return this.invalidControlScroll.next(true);
  }
}
